import { Injectable, inject } from '@angular/core';
import { LoggerFactory } from '../logger/logger-factory.service';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { CommonNotificationEmetteurType } from './common-notification-handler';
import { of } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import {
  EventNameNotification,
  GetOtResult,
  MultiTechNotification,
  NotificationsAlertProvider,
  NotificationTypeItem,
} from '../notifications-alert/notifications-alert.provider';

export interface IMultiTechNotifications {
  /**
   * Définie par le plugin
   * true si la notification est ouverte
   * à partir de la notification reçue dans la barre
   * des notifs (application en arrière plan)
   */
  tap?: boolean;

  /**
   * Type de notification multitech (OT ou STI)
   */
  typeItem: NotificationTypeItem;

  /**
   * Type d'émetteur des notifications
   * CRT ou Multitech
   */
  typeEmetteur: CommonNotificationEmetteurType;

  /**
   * Libellé de l'OT pour le STI
   */
  libelleOt?: string;

  /**
   * Identifiant de l'OT ou du STI suivant le cas
   */
  id?: string;

  /**
   * Type de l'OT
   */
  typeOt?: string;

  /**
   * Identifiant de l'OT
   */
  idOt?: string;

  /**
   * Type de notification précise
   */
  eventName?: EventNameNotification;

  /**
   * Date de début de planification
   */
  dateDebutPlanification?: string;

  /**
   * Date de fin de planification
   */
  dateFinPlanification?: string;

  /**
   * Société à laquelle faire l'OT
   */
  societe?: string;

  /**
   * Libellé de l'intervention
   */
  intitule?: string;

  /**
   * Identifiant de l'utilisateur
   */
  idUtilisateur?: string;

  /**
   * Identifiant de l'utilisateur
   */
  est_astreinte?: Boolean;
}

/*
  Classe qui récupère les autres notifications que CRT
*/
@Injectable({ providedIn: 'root' })
export class MultiTechNotificationHandlerProvider {
  private notificationsAlert = inject(NotificationsAlertProvider);
  /**
   * Logger
   */
  private logger: LoggerWrapper;

  /**
   * Constructeur
   */
  constructor(private loggerFactory: LoggerFactory) {
    this.logger = this.loggerFactory.getInstance(this);
  }

  /**
   * Récupère et redispatch la notification
   * @param notification
   */
  public handleNotification(notification: IMultiTechNotifications) {
    this.logger.log('handleNotification', notification);

    if (notification.tap) {
      // Ouverture quand l'applicatin était en backgroud au moment de la réception de la notification
      if (
        notification.typeItem === NotificationTypeItem.OT &&
        notification.eventName === EventNameNotification.DIEmergency
      ) {
        return of({
          type: MultiTechNotification.DIEmergency,
          getOtResult: GetOtResult.acknowledgeError,
          irId: notification.id,
          notificationEventName: notification.eventName,
          notificationEstAstreinte: notification.est_astreinte,
        });
      } else if (
        notification.typeItem === NotificationTypeItem.OT &&
        notification.eventName === EventNameNotification.DICascade
      ) {
        return of({
          type: MultiTechNotification.DICascade,
          getOtResult: GetOtResult.ok,
          irId: notification.id,
          notificationEventName: notification.eventName,
          notificationEstAstreinte: notification.est_astreinte,
        });
      } else if (
        notification.typeItem === NotificationTypeItem.OT &&
        notification.eventName === EventNameNotification.DIUo
      ) {
        return of({
          type: MultiTechNotification.DIUo,
          getOtResult: GetOtResult.ok,
          irId: notification.id,
          notificationEventName: notification.eventName,
          notificationEstAstreinte: notification.est_astreinte,
        });
      } else if (
        notification.typeItem === NotificationTypeItem.STI ||
        notification.eventName === EventNameNotification.STIEndStep
      ) {
        return of({
          type: MultiTechNotification.STIEndStep,
          idSti: notification.id,
          notificationEventName: notification.eventName,
          libelleOt: notification.libelleOt,
        });
      } else return of();
    } else {
      return this.openNotificationToast(notification);
    }
  }

  /**
   * Ouvre un toast de notifications
   * @param notification
   */
  private openNotificationToast(notification: IMultiTechNotifications) {
    if (
      notification.typeItem === NotificationTypeItem.OT &&
      notification.eventName === EventNameNotification.DIEmergency
    ) {
      return fromPromise(this.notificationsAlert.showPopupDIEmergency(notification));
    } else if (
      notification.typeItem === NotificationTypeItem.OT &&
      notification.eventName === EventNameNotification.DIUo
    ) {
      return fromPromise(this.notificationsAlert.showPopupDIUo(notification));
    } else if (
      notification.typeItem === NotificationTypeItem.OT &&
      notification.eventName === EventNameNotification.DICascade
    ) {
      return fromPromise(this.notificationsAlert.showPopupDICascade(notification));
    } else if (
      notification.typeItem === NotificationTypeItem.STI ||
      notification.eventName === EventNameNotification.STIEndStep
    ) {
      return fromPromise(this.notificationsAlert.showPopUpEndSTI(notification));
    } else {
      return of({
        notificationTypeItem: notification.typeItem,
      });
    }
  }
}
